"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base64_1 = require("@stablelib/base64");
const b64 = {
    urlSafe: (str) => str.replace(/\+/g, '-').replace(/\//g, '_'),
    urlUnsafe: (str) => str.replace(/\-/g, '+').replace(/\_/g, '/'),
    encode: function b64Encode(input) {
        if (typeof Buffer !== 'undefined') {
            return b64.urlSafe(Buffer.from(input, 0, input.length).toString('base64'));
        }
        return base64_1.encodeURLSafe(input);
    },
    decode: function b64Decode(input) {
        if (typeof Buffer !== 'undefined') {
            const buf = Buffer.from(input, 'base64');
            return new Uint8Array(buf, 0, buf.length);
        }
        return base64_1.decodeURLSafe(b64.urlSafe(input));
    }
};
exports.default = b64;
